export default __webpack_public_path__ + "assets/images/wallet-connect-logo-round-a259b00e1d9b6b32514facee59ea5007.svg";